<template src="./Quote.html" />

<script>
export default {
name: "Quote"
}
</script>

<style scoped lang="scss" src="./Quote.scss" />

<style scoped lang="scss">
  .quote {
    &__fpo {
      position: relative;
      &:before {
        content: 'FPO';
        display: block;
        position: absolute;
        color: #ff00d5;
        font-size: 120px;
        font-weight: 700;
        transform: translate(-50%, -50%) rotate(30deg);
        top: 50%;
        left: 50%;
        z-index: 2;
        @media (max-width: $mobile) {
          font-size: 92px;
        }
      }
    }
  }
</style>
